<script setup lang="ts">
/** Shown only on a green or yellow result, where the risk of over-reading the colour is real. */
import * as da from '@/strings/da'
</script>

<template>
	<aside class="caveat">
		<h3 class="heading">{{ da.caveat.heading }}</h3>
		<p>{{ da.caveat.body }}</p>
		<p class="last">{{ da.caveat.last }}</p>
	</aside>
</template>

<style scoped>
.caveat {
	padding: 16px 18px;
	border: 1px dashed var(--tcx-teal);
	border-radius: var(--tcx-radius-sm);
	background: #fafbfb;
}

.heading {
	font-size: 1rem;
	font-weight: 700;
}

p {
	margin: 8px 0 0;
	max-width: 62ch;
	font-size: 0.875rem;
	color: var(--tcx-muted);
}

.last {
	margin-bottom: 0;
}
</style>
